import Whiteboard from './components/Whiteboard'
import Big from './components/BigWhiteboard'

export const BigWhiteboard = Big

export default Whiteboard


// WEBPACK FOOTER //
// ./src/index.js